import React, { useState, useEffect } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import { Table, Divider, Button } from "antd";
import { Link } from "react-router-dom";
import "./style.scss";

const columns = [
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },

  {
    title: "Name",
    dataIndex: "firstName",
    key: "firstName",
  },
  {
    title: "Phone",
    dataIndex: "lastName",
    key: "lastName",
  },
  {
    title: "Role",
    index: "admin",
    dataIndex: "admin",
    key: "admin",
    filters: [
      { text: "Admin", value: true },
      { text: "User", value: false },
    ],
    onFilter: (value, record) => {
      return record.admin === value;
    },
    render: (admin) => <div>{admin ? <p>admin</p> : <p>user</p>}</div>,
  },
  {
    title: "Create Date",
    dataIndex: "createdAt",
    key: "createdAt",
  },
  {
    title: "Action",
    key: "action",
    render: (text, record) => (
      <span>
        <Link to={`/users/show/${record._id}`}>Show</Link>
        <Divider type="vertical" />
        <Link to={`/users/edit/${record._id}`}>
          <Button type="primary">Edit</Button>
        </Link>
      </span>
    ),
  },
];

function App() {
  const [response, setResponse] = useState([]);
  const [userCount, setCount] = useState();

  useEffect(() => {
    Axios.get(baseUrl + "user")
      .then((response) => {
        setResponse(response.data.users);
        setCount(response.data.users.length);
      })
      .catch(function (error) {});
  }, []);
  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end ",
          padding: "50px 0",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "20px",
          }}
        >
          {/* <h5>Toplam Kullanici Sayisi</h5>
          <h2>{userCount}</h2> */}
        </div>
        <Link to="/users/create">
          <div
            style={{
              width: "150px",
              height: "50px",
              backgroundColor: "#27ae60",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "5px",
              boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
            }}
          >
            <span style={{ color: "#fff", fontSize: "15px" }}>
              Yeni Kullanici Oluştur
            </span>
          </div>
        </Link>
      </div>
      <Table key={"usersTable"} columns={columns} dataSource={response} />
    </div>
  );
}

export default App;
